import React from 'react'
import { FaEllipsisV } from 'react-icons/fa'

import './ThreeDots.css'

// Só um menu aberto por vez: abrir um fecha o que estava aberto (ex.: linhas de uma tabela).
let menuAberto = null

export default class ThreeDots extends React.Component {
  state = {
    show: false,
  }

  componentWillUnmount() {
    if (menuAberto === this) menuAberto = null
  }

  close = () => {
    if (menuAberto === this) menuAberto = null
    this.setState({ show: false })
  }

  // Events
  onMenuItemClicked = item => {
    this.props.onClick(item)
    this.close()
  }

  onTheeDotsClicked = () => {
    if (this.state.show) {
      this.close()
      return
    }
    if (menuAberto) menuAberto.close()
    menuAberto = this
    this.setState({ show: true })
  }

  // Render
  render() {
    const { items, color = 'black' } = this.props
    const { show } = this.state
    return (
      <div className="ThreeDots__container">
        <div className="ThreeDots" onClick={this.onTheeDotsClicked}>
          <FaEllipsisV color={color} />
        </div>
        {show ? (
          <div className="menu__container">
            <ul>
              {items.map(i => (
                <li onClick={() => this.onMenuItemClicked(i)} key={i}>
                  {i}
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
    )
  }
}
